export default __webpack_public_path__ + "static/media/Vertical_switch.ee9d7e3c.svg";